import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import evidenceCloseIcon from '../../assets/icons/purchase-evidence-close.svg';
import './manualPurchase.css';

const EvidenceLightbox = ({ open, onClose, children }) => {
  const dialogRef = useRef(null);
  const closeRef = useRef(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    if (open && !dialog.open) {
      dialog.showModal();
      closeRef.current?.focus({ preventScroll: true });
    }
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return createPortal(
    <dialog
      ref={dialogRef}
      aria-label='Payment evidence'
      className='purchase-evidence-lightbox m-0 h-screen max-h-none w-screen max-w-none bg-transparent p-0 backdrop:bg-black/50'
      onCancel={event => {
        event.preventDefault();
        onClose();
      }}
    >
      <div className='flex h-full w-full items-center justify-center'>
        {children}
      </div>
      <button
        ref={closeRef}
        type='button'
        aria-label='Close payment evidence'
        className='absolute right-[30px] top-[30px] flex h-14 w-14 items-center justify-center rounded-full bg-white/50 text-[#344154] focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600'
        onClick={onClose}
      >
        <img src={evidenceCloseIcon} alt='' className='h-9 w-9' />
      </button>
    </dialog>,
    document.body
  );
};

export default EvidenceLightbox;
